import React, {FC} from 'react';
import {Button} from '@mui/material';
import {observer} from "mobx-react";
import {Stack} from "@mui/system";


type TProps = {}

export const SaveUser: FC<TProps> = observer((props: TProps) => {


    return (
        <Stack direction={'row'} justifyContent={'flex-end'} spacing={2}>
            <Button
                type="submit"
                variant={'contained'}
            >
                Save
            </Button>
        </Stack>
    )

})
